<script>
export const defaultCommissionPoints = [
    "Strony ustaliły wartość w/w pojazdu na: {cenapojazdu}",
    "Wysokość należnej Komisantowi prowizji wynosi: {prowizjakomisanta}",
    "Komitent za pośrednictwem AUTO-KOMISU przeniesie na rzecz kupującego własność pojazdu określonego powyżej.",
    "Komisant zobowiązuje się do zabezpieczenia pozostawionego mu pojazdu, jednak w przypadku wydarzeń losowych niezależnych od woli Komisanta lub kradzieży nie ponosi odpowiedzialności za powstałe straty.",
    "Komitent wyraża zgodę na dokonanie przez Komisanta lub osoby zainteresowane zakupem jazd próbnych i wykonanie badań technicznych w/w pojazdu.",
    "Jeżeli Komisant sprzeda samochód za cenę wyższą od ceny ustalonej w &1 umowy to uzyskana nadwyżka stanowi opodatkowany dochód Komisanta.",
    "Jeżeli Komitent wycofa się ze sprzedaży wstawionego do komisu pojazdu przed ustalonym terminem, Komitent zobowiązuje się do zapłaty Komisantowi wynagrodzenia w wysokości 30 zł netto za każdy rozpoczęty dzień postoju pojazdu w komisie, licząc od dnia wystawienia Umowy. Komisant może zrezygnować z prowizji za porozumieniem stron - Komisant/Komitent.",
    "Komisant w razie niesprzedania pojazdu w ciągu ........... dni, licząc od dnia podpisania umowy, może odstąpić od umowy i wezwać Komitenta do odebrania pojazdu w terminie do 5 dni roboczych od dnia powiadomienia Komitenta. Za zwłokę naliczana jest opłata 30 zł netto za każdą dobę.",
    "Komitent oświadcza że: Stan techniczny w/w pojazdu jest mu znany. Pojazd stanowi jego wyłączną własność i pochodzi z legalnego źródła. Pojazd jest wolny od wad prawnych oraz praw osób trzecich. Pojazd nie jest przedmiotem żadnego postępowania karnego, cywilnego, administracyjnego. Na pojeździe nie jest ustanowiony bankowy zastaw rejestrowy, a także nie stanowi zabezpieczenia na rzecz Urzędu Skarbowego. Ponosi odpowiedzialność za wady prawne dokumentów i wady ukryte pojazdu. W przypadku odstąpienia Komitenta od sprzedaży w/w pojazdu Komitent zwróci Kupującemu podwójną kwotę zadatku. W przypadku odstąpienia Kupującego od kupna w/w pojazdu lub niewpłacenia pozostałej kwoty w ustalonym terminie kupujący traci zadatek. W przypadku zakupu na raty, jeżeli weryfikacja dokonana przez bank wypadnie negatywnie, Komitent zwróci Kupującemu zadatek bez potrąceń. Warunki, na których pojazd został przyjęty do komisu są mi znane i akceptuje je.",
    "Wszystkie sprawy sporne, nieuregulowania lub niejasności wynikające z umowy będą rozwiązywane polubownie w formie pisemnej. W innym przypadku rozstrzygać będzie Sąd, pod który podlega Komisant."
]
</script>

<script setup>
import { onMounted, ref, nextTick } from 'vue'

const props = defineProps({
    modelValue: {
        type: Array,
        default: () => []
    },
    title: { type: String, default: 'Umowa' },

})
const headerRef = ref(null)
const sectionCollapse = ref(false)
const emit = defineEmits(['update:modelValue'])

const updatePoint = (index, value) => {
    const updated = [...props.modelValue]
    updated[index] = value
    emit('update:modelValue', updated)
}

const addPoint = () => {
    if (props.modelValue.length < 21) {
        emit('update:modelValue', [...props.modelValue, ''])
    }
}
const toggleSection = async () => {
    sectionCollapse.value = !sectionCollapse.value
    if (sectionCollapse.value) {
        await nextTick()
        headerRef.value?.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
}
const resetToDefault = () => {
    emit('update:modelValue', [...defaultCommissionPoints])
}

onMounted(() => {
    if (!props.modelValue || props.modelValue.length === 0) {
        resetToDefault()
    }
})
</script>

<template>
    <div class="row g-3 mb-4">
        <div ref="headerRef"
            class="col-12 d-flex justify-content-between align-items-center border-bottom pb-2 cursor-pointer"
            @click="toggleSection">
            <h6 class="fw-bold mb-0">{{ title }}</h6>
            <div class="btn-group">
                <button type="button" class="btn btn-sm btn-outline-secondary py-0 px-2 me-2" @click.stop="resetToDefault">
                    <i class="bi bi-arrow-counterclockwise me-1"></i>Przywróć domyślne
                </button>
                <button type="button" class="btn btn-sm btn-link text-decoration-none p-0">
                    <i class="bi" :class="sectionCollapse ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
                </button>
            </div>

        </div>

        <div class="col-12" v-show="sectionCollapse">
            <div class="row g-3">
                <div v-for="(point, idx) in modelValue" :key="idx" class="mb-3">
                    <label class="form-label small fw-semibold">Punkt {{ idx + 1 }}</label>
                    <textarea class="form-control form-control-sm" rows="2" :value="point"
                        @input="updatePoint(idx, $event.target.value)" placeholder="Wpisz treść punktu..."></textarea>
                </div>

                <button type="button" class="btn btn-sm btn-outline-primary" @click="addPoint"
                    v-if="modelValue.length < 21">
                    <i class="bi bi-plus-circle me-1"></i>Dodaj kolejny punkt
                </button>
            </div>
        </div>
    </div>
</template>